module.exports = __webpack_public_path__ + "static/media/banner.78bc53b3.png";